export default "__VITE_ASSET__Dao8WEQL__"